import { FC, SVGProps } from 'react'

export const Smartphone: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.83311 4.5C7.29337 4.5 6.85583 4.93754 6.85583 5.47727V19.2955C6.85583 19.8352 7.29337 20.2727 7.83311 20.2727H16.4695C17.0092 20.2727 17.4467 19.8352 17.4467 19.2955V5.47727C17.4467 4.93754 17.0092 4.5 16.4695 4.5H7.83311ZM5.35583 5.47727C5.35583 4.10911 6.46495 3 7.83311 3H16.4695C17.8376 3 18.9467 4.10911 18.9467 5.47727V19.2955C18.9467 20.6636 17.8376 21.7727 16.4695 21.7727H7.83311C6.46495 21.7727 5.35583 20.6636 5.35583 19.2955V5.47727Z"
			fill="currentColor"
		/>
	</svg>
)
